import { matchPath } from 'react-router-dom';

export const getFirstMatchedRoute = (routes, pathname) => {
  for (const route of routes) {
    const { path } = route;
    if (matchPath(pathname, {
      path,
      exact: true,
    })) {
      return route;
    }
  }
  return null;
};
